import React, { useEffect, useRef, useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './Layout.scss';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from '../component/ErrorBoundary';
import UsageLimitBanner from '../component/DashboardBanner/UsageLimitBanner';

const Layout = () => {
	const [collapsed, setCollapsed] = useState(false);
	const inputRef = useRef(null);

	const location = useLocation();
	// Clear URL query parameters across all modules
	useEffect(() => {
		if (window.location.search) {
			window.history.replaceState(null, '', window.location.pathname);
		}
	}, [location.search, location.pathname]);

	return (
		<div>
			<div>
				<Navbar
					collapsed={collapsed}
					inputRef={inputRef}
					setCollapsed={setCollapsed}
				/>
				<div className="d-flex">
					<Sidebar
						inputRef={inputRef}
						collapsed={collapsed}
						setCollapsed={setCollapsed}
					/>
					<div className="layout-wrapper">
						{/*
						 * Rendered in the layout (not inside a specific page) so a 90%+
						 * usage alert stays visible across the whole dashboard rather than
						 * being a per-page notice that disappears on navigation.
						 *
						 * Placed INSIDE .layout-wrapper rather than above the d-flex row:
						 * out there it was a sibling of the sidebar, so it spanned the
						 * full viewport width, sat over the sidebar and pushed the entire
						 * app down. .layout-wrapper already starts below the navbar
						 * (margin-top: 60px) and is width-constrained beside the sidebar
						 * at every breakpoint, so the banner now occupies the content
						 * column only and cannot overflow it.
						 */}
						<UsageLimitBanner />
						{/*
						 * Wraps the routed page only, so a crash inside one page keeps the
						 * navbar and sidebar usable and the user can navigate away —
						 * rather than React unmounting the whole tree and leaving a blank
						 * screen. `key` on the route path resets the boundary on
						 * navigation, otherwise a page that errored once would stay
						 * errored after moving elsewhere.
						 */}
						<ErrorBoundary key={location.pathname}>
							<Outlet />
						</ErrorBoundary>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Layout;
